import { render, staticRenderFns } from "./PrescriptionHomePage.vue?vue&type=template&id=640905f5&"
import script from "./PrescriptionHomePage.vue?vue&type=script&lang=ts&"
export * from "./PrescriptionHomePage.vue?vue&type=script&lang=ts&"
import style0 from "./PrescriptionHomePage.vue?vue&type=style&index=0&id=640905f5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports